/*
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2025-02-11 17:48:06
 * @FilePath: \h5-front\src\models\category-api.js
 * @Description: /category 分类接口
 */

import { Base } from "./base"
class CategoryService extends Base {
    constructor(opt) {
        super(opt)
    }

    /**查询所有分类 */
    getCategoryAll(params) {
        let url = '/all'
        return this.get(url, { params })
    }

    /**查询分类详情 */
    getCategoryInfo(params) {
        let url = '/'
        return this.get(url,{params})
    }
}

export default new CategoryService({ prefix: '/v1/category' })